import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TooltipService {
  readonly text$ = new BehaviorSubject<string>('');

  private _clearTimer: ReturnType<typeof setTimeout> | null = null;

  set(text: string): void {
    if (this._clearTimer) { clearTimeout(this._clearTimer); this._clearTimer = null; }
    this.text$.next(text);
  }

  clear(): void {
    this._clearTimer = setTimeout(() => { this.text$.next(''); this._clearTimer = null; }, 120);
  }
}
